export default {
    'documentoEvidencias.PesoPdfInvalido': 'El archivo pdf supera el peso permito de 15MB',
    'documentoEvidencias.BotonArchivo': 'Archivo',
    'documentoEvidencias.alerta.limiteImagenes': 'Ha excedido el máximo de imágenes',
    'documentoEvidencias.alerta.archivoInvalido': 'El tipo de archivo ingresado es inválido',
    'documentoEvidencias.productoSinImagenes': 'No hay imágenes cargadas',
};
